import {
    Box,
} from '@mui/material';
import Legend from './Legend';
import FlexTimeAccountBalance from '../../shared/FlexTimeAccountBalance';

function TimeKeeperCalendarFooter({ legend, currentFlexTimeAccount }) {

    return (
        <>
            <Box sx={{ display: 'flex',}}> 
                <Legend
                    sx={{ mr: 10, flex: 1, justifyContent: 'space-between' }}
                    items={legend}
                />
                <Box sx={{ flex: 1 }}>
                    {
                        currentFlexTimeAccount !== null &&
                        <FlexTimeAccountBalance balance={currentFlexTimeAccount} />
                    }
                </Box>
            </Box>
        </>
    );
};

export default TimeKeeperCalendarFooter

